import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AudioInputComponent } from '@app/shared/audio/components/audio-input.component';
import { RecordAudioComponent } from '@app/shared/audio/components/record-audio.component';
import { SynthesizeSpeechComponent } from '@app/shared/audio/components/synthesize-speech.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [SharedModule, ReactiveFormsModule],
  declarations: [SynthesizeSpeechComponent, AudioInputComponent, RecordAudioComponent],
  exports: [AudioInputComponent],
})
// @ts-ignore - Webstorm is complaining that 'TextToSpeechModule' is a duplicate identifier
export class AudioModule {}
